import { post } from '../axios'

// 添加倒计时配置
export function pdpCountdown_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPCOUNTDOWN}/pdpCountdown/add`,
    map,
    option
  ).then(response => response)
}

// 查询倒计时配置
export function pdpCountdown_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPCOUNTDOWN}/pdpCountdown/detail`,
    map,
    option
  ).then(response => response)
}
